(function (Cobalt) {
    var Mobile = /** @class */ (function () {
        function Mobile() {
        }
        /**
         Returns a string of the device the user is using based on their user agent.
         Return values include: 'windows', 'ios', 'android', and 'mac'
         */
        Mobile.DetectMobileDevice = function () {
            var UA = navigator.userAgent;
            var platform = 'windows';
            if (UA.match(/Windows Phone 8/i) != null && UA.match(/Touch/i) !== null) {
                platform = 'windows';
            }
            else if (UA.match(/iPhone|iPod/i) != null || (UA.match(/iPad/))) {
                platform = 'ios';
            }
            else if (UA.match(/Android/i) != null) {
                platform = 'android';
            }
            else if (UA.match(/Mac_PowerPC|Macintosh/i)) {
                platform = 'mac';
            }
            return platform;
        };
        return Mobile;
    }());
    Cobalt.Mobile = Mobile;
})(Cobalt || (window.Cobalt = {}));


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.Mobile.js